'use client';

import React from 'react';

import clsx from 'clsx';
import { usePathname, useSearchParams } from 'next/navigation';

import { NavigationLikesButton } from './NavigationLikesButton';
import { NavigationMessagesButton } from './NavigationMessagesButton';
import { NavigationMobileSearchBarButton } from './NavigationMobileSearchBarButton';
import { NavigationProfileDropdown } from './NavigationProfileDropdown';
import { NavigationQuickAccessBag } from './NavigationQuickAccessBag';
import { NavigationSellButton } from './NavigationSellButton';
import { NavigationTextButton } from './NavigationTextButton';
import styles from './styles.module.css';

import { NavCtaActionTypes } from '@/modules/activityTracker/constants';
import { useShowHomepageSearchBar } from '@/modules/home/hooks/useShowHomepageSearchBar';
import { getLoginRedirectParams } from '@/modules/login/helpers';
import { useProductsSearchBar } from '@/modules/product/hooks/useProductsSearchBar';
import { useSignup } from '@/modules/signup/hooks/useSignup';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

export function Navigation() {
  const [isAuthenticated] = useCurrentUser();
  const { url: signupUrl } = useSignup();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const { visibleSearchBar: isHomepageSearchBarVisible } =
    useShowHomepageSearchBar();
  const { isVisible: isProductSearchBarVisible } = useProductsSearchBar();
  const currentPath = searchParams.size
    ? `${pathname}?${searchParams}`
    : pathname;
  const hideSearchIcon =
    isHomepageSearchBarVisible ||
    isProductSearchBarVisible ||
    Boolean(pathname.match(/^\/(?:([a-z]{2})\/)?sell/));

  return (
    <nav className={styles.nav}>
      <ul
        className={clsx(styles.navigationButtons, {
          [styles['navigationButtons--loggedIn']]: isAuthenticated,
        })}
        id="main-nav"
      >
        {isAuthenticated && <NavigationSellButton />}
        <li className={styles.iconGroup}>
          <ul className={styles.iconGroupList}>
            {!hideSearchIcon && <NavigationMobileSearchBarButton />}
            {isAuthenticated && <NavigationMessagesButton />}
            <NavigationLikesButton />
            <NavigationQuickAccessBag />
          </ul>
        </li>

        {isAuthenticated && <NavigationProfileDropdown />}
        {!isAuthenticated && (
          <>
            <NavigationSellButton />
            <NavigationTextButton
              ctaType={NavCtaActionTypes.NAV_SIGNUP_CTA}
              href={signupUrl}
              ctaText="SignUp"
            />
            <NavigationTextButton
              ctaType={NavCtaActionTypes.NAV_LOGIN_CTA}
              href={`/login/${getLoginRedirectParams(
                searchParams.get('redirect') || currentPath
              )}`}
              ctaText="Login"
            />
          </>
        )}
      </ul>
    </nav>
  );
}
